import React from 'react'
import { ReactComponent as CopyIcon } from './copy-icon.svg'
import styled from 'shared/theme'
import { useButton } from '@react-aria/button'

export default CopyIcon

type CopyButtonProps = Omit<React.HTMLProps<HTMLButtonElement>, 'children'>
const CopyIconButtonElement = styled(CopyIcon)<CopyButtonProps>`
    cursor: pointer;
    color: ${props => props.theme.colors.textSecondary};
`

export function CopyIconButton(props: CopyButtonProps): JSX.Element {
    const ref = React.useRef<HTMLButtonElement>()
    const { buttonProps } = useButton({ elementType: 'svg' }, ref as any)
    return <CopyIconButtonElement {...buttonProps} {...(props as any)} />
}
